jQuery.noConflict();
(function( $ ) {
    $(function() {
        var mm = [];
        mm.afterLoad = false;
        mm.active = false;

        $(window).on('load', function(){
            megaMenuInit();
        });

        function megaMenuInit(){
            redrawMenu();
            mm.afterLoad = true;
        }

        setTimeout(function(){
            if (mm.afterLoad == false) {
                megaMenuInit();
            }
        }, 2000);

        function redrawMenu() {
            if ($('#menu-main .mega-child').length>0) {
                var megaMenu = '',
                    menus = '',
                    first = false;
                $.each($('#menu-main .mega-child'), function(e){
                    var html = $(this).html(),
                        parent = $(this).attr('data-parent'),
                        id = $(this).attr('id');
                        menus = menus + '<ul class="mega-child" id="'+id+'" data-parent="'+parent+'" >' + html + '</ul>';
                        if (first == false) {
                            first = id;
                            mm.parent = parent;
                            mm.parent_class  = $('#'+parent).attr('data-pcat');
                        }
                    $(this).remove();
                });
                megaMenu = megaMenu + '<div class="mm-wrap '+mm.parent_class +'" data-cls="'+mm.parent_class +'">';
                megaMenu = megaMenu + '<div class="mm-line"></div>';
                megaMenu = megaMenu + '<div class="mega-menus">';
                megaMenu = megaMenu + menus;
                megaMenu = megaMenu + '</div></div>';
                $('header.header').append(megaMenu);
            }
            addActiveState();
            bindMegaHovers();
        }

        function addActiveState(){
            if ($('.nav-wrap ul li a[data-active-mitem=true]').length>0) {
                var page_url = $('.nav-wrap ul li a[data-active-mitem=true]').attr('href');
                urlAddActive(page_url);
                var lvlUpUrl = $('.nav-wrap ul li a[data-active-mitem=true]').parent().parent().parent().find('a').attr('href');
                if (lvlUpUrl != undefined && lvlUpUrl != '#' && lvlUpUrl != '') {
                    urlAddActive(lvlUpUrl);
                    var lvlTopUrl = $('.nav-wrap ul li a[data-active-mitem=true]').parent().parent().parent().parent().parent().find('a').attr('href');
                    if (lvlTopUrl != undefined && lvlTopUrl != '#' && lvlTopUrl != '') {
                        urlAddActive(lvlTopUrl);
                    }
                }
            }
        }

        function urlAddActive(url){
            $('a[href="'+url+'"]').parent().addClass('active');
        }

        function bindMegaHovers(){
            $.each($('.mega-child'), function(){
                var id = $(this).attr('id'),
                    items = $('#'+id+' > li').length;
                $(this).addClass('items-'+items);
            });

            $('body').on('mouseenter', '.header-nav nav > ul > li', function(){
                var id = $(this).attr('id'),
                    cls = $(this).attr('data-pcat');
                $('#'+mm.parent).removeClass('mactive');
                $('.mega-child').removeClass('mactive');
                $('.mm-wrap').removeClass(mm.parent_class).addClass(cls);
                mm.parent = id;
                mm.parent_class = cls;
                $('#mega-'+id).addClass('mactive');
                var childHeight = $('#mega-'+id).outerHeight();
                childHeight = childHeight + 30;
                if (childHeight < 410) {
                    childHeight = 410;
                }
                $(this).addClass('mactive');
                mm.active = true;
                $('.mm-wrap').addClass('mm-active').attr('style', 'min-height: '+childHeight+'px;');
            });

            $('body').on('mouseleave', '.mm-wrap', function(){
                $('.mm-wrap').removeClass('mm-active').attr('style', '');
                mm.active = false;
            });
        }


    });
})(jQuery);